module.exports = __webpack_public_path__ + "static/media/banner6.d91d297c.jpg";